import type {FC} from 'react';

import {Heading} from '@/modules/foundation/components/typography/heading';

import {RadioTile} from '../../form/RadioTile';

import type {ProductVariantFragment} from './query';

type ItemVariantSelectorProps = {
	variants: ProductVariantFragment[];
	defaultVariantId?: string | null;
};

export const ProductVariantSelector: FC<ItemVariantSelectorProps> = ({
	variants,
	defaultVariantId,
}) => {
	if (variants.length === 1) {
		return <input type="hidden" name="variantId" value={variants[0]._key} />;
	}

	return (
		<fieldset className="mb-8">
			<Heading level={2} size="h3" className="mb-3" asChild>
				<legend>Variant</legend>
			</Heading>

			<div className="flex flex-wrap gap-4">
				{variants.map((variant) => (
					<div key={variant._key}>
						<RadioTile
							id={variant._key}
							name="variantId"
							value={variant._key}
							defaultChecked={defaultVariantId === variant._key}
						>
							{variant.name}
						</RadioTile>
					</div>
				))}
			</div>
		</fieldset>
	);
};
